import { render, staticRenderFns } from "./ListGrupoUsuario.vue?vue&type=template&id=6ae3e7c3"
import script from "./ListGrupoUsuario.vue?vue&type=script&lang=js"
export * from "./ListGrupoUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports